import { createSubApp } from '../../../commons/portal-init/create-sub-app'
import { getContext } from '../../../commons/portal-init/get-context'
import { applyFooterTheme } from '../common-header/theme'
import FooterCopyright from './footer-copyright.vue'
import { normalizeFooter } from './footer-config.js'
import { createAppI18n } from '../../../shared/setup-i18n'
import { applyMinimalistLayout, createFooterContainer, resolveMountTarget } from './layout.js'

export default async function footerCopyrightInit(rawConfig) {
  try {
    const ctx = getContext()
    const isMinimalist = Boolean(ctx.useSimplifiedPortal && ctx.useSimplifiedHeaderRaw)

    const mountTarget = resolveMountTarget({ isMinimalist })
    if (!mountTarget) return

    const footer = normalizeFooter(rawConfig, { legacy: ctx.footConfig ?? {} })

    if (isMinimalist) applyMinimalistLayout(mountTarget)

    const container = createFooterContainer()
    mountTarget.appendChild(container)

    const i18n = createAppI18n('footerCopyright')
    createSubApp({
      component: FooterCopyright,
      container,
      scope: 'footer-copyright',
      plugins: [i18n],
      props: { config: footer, isMinimalist }
    })
    applyFooterTheme(footer.style)
  } catch (err) {
    console.error('[footer-copyright] Init failed:', err)
  }
}
